import React from 'react'

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import {
	AlertColor,
	AlertPropsColorOverrides,
	Paper,
	Typography,
} from '@mui/material'
import { OverridableStringUnion } from '@mui/types'
import { countWords } from 'utils/countWords'

import {
	educationCardStyles,
	infoIconStyles,
	messageTypographyStyles,
} from './WarningMessage.styles'

type WarningMessageProps = {
	color?: OverridableStringUnion<AlertColor, AlertPropsColorOverrides>
	prompt: string
}

const WarningMessage: React.FC<WarningMessageProps> = ({ prompt }) => {
	const wordCount = countWords(prompt)
	const showEducationCard = wordCount >= 21

	if (!showEducationCard) return null

	return (
		<Paper
			id="topic-refinement-education"
			role="status"
			elevation={2}
			sx={educationCardStyles}
		>
			<InfoOutlinedIcon sx={infoIconStyles} />
			<Typography variant="body2" sx={messageTypographyStyles}>
				Keeping the problem statement short helps keep the ideation
				open. Consider the topic refinement suggestions below.
			</Typography>
		</Paper>
	)
}

export default WarningMessage
